import Head from 'next/head'
import { useAccountMeQuery } from '~/api/accounts'
import { links } from '~/common/links'
import { Msg, useMsg } from '~/common/localizationUtils'
import { trackedLinkClick } from '~/third_party/analytics'
import { Breadcrumbs, NavTab, NavTabList, NavTabs, PageHeader, PageTitle } from '~/design_system'
import { UserTasksList } from '~/user_tasks/UserTasksList'

const TaskPageHeader = () => {
  const msg = useMsg()
  const meQuery = useAccountMeQuery()
  const showApprovals = meQuery.isEmployerRole
  return (
    <PageHeader pb={showApprovals ? 0 : 4}>
      <Breadcrumbs links={[links.homeLogin, { name: msg('tasks.card.header') }]} />
      <PageTitle>
        <Msg id="tasks.card.header" />
      </PageTitle>
      {showApprovals && !meQuery.isLoading && (
        <NavTabs defaultIndex={0} fontSize="md">
          <NavTabList>
            <NavTab href="/tasks/list" onClick={trackedLinkClick(undefined, 'tasks_tab', { tab_name: 'tasks' })}>
              <Msg id="tasks.card.header" description="Tasks" />
            </NavTab>
            <NavTab href="/approvals" onClick={trackedLinkClick(undefined, 'approvals_tab', { tab_name: 'approvals' })}>
              <Msg id="common.ui.approvals" description="Approvals" />
            </NavTab>
          </NavTabList>
        </NavTabs>
      )}
    </PageHeader>
  )
}

export default function TasksSettingsPage() {
  return (
    <>
      <Head>
        <title>Tasks - Workday VNDLY</title>
      </Head>
      <TaskPageHeader />
      <UserTasksList />
    </>
  )
}
